
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.vcprinter.factory:PrinterHelper
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcprinter')
    .factory('PrinterHelper', PrinterHelper);
  
  
  PrinterHelper.$inject = ['Printer', '$uibModal', '$log', 'Rlog'];
  
  function PrinterHelper(Printer, $uibModal, $log, Rlog) {
    let PrinterHelperBase = {};
    
    PrinterHelperBase.editPrinter = editPrinter;
    PrinterHelperBase.addPrinter = addPrinter;
    
    
    function addPrinter(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><printerform printer="vm.printer" parentsave="vm.childsave(printer)" oncancel="vm.cancel()"></printernew></div>',
        controllerAs: 'printeraCtrl',
        controller: ['printer', function () {
          let vm = this;
          vm.printer = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(printer) {
            Printer.$create(printer).$then(function (newprinter) {
              vm.created = true;
              success(newprinter);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ printer-helper.addPrinter: ', err);
              Rlog.error('vcutils.printer', 'printer-helper.addPrinter', 'Creation of new printer failed: ', {printer: printer});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          printer: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editPrinter(lprinter) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><printerform printer="printereCtrl.printer" parentsave="printereCtrl.childsave(printer)" oncancel="printereCtrl.cancel()"></printerform></div>',
        controllerAs: 'printereCtrl',
        controller: ['printer', function (sprinter) {
          let vm = this;
          vm.printer = sprinter;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(printer) {
            // vm.printer = angular.copy(printer);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in printer) {
              if (printer.hasOwnProperty(key)) {
                vm.printer[key] = printer[key];
              }
            }
            
            if (vm.printer.$hasPendingActions()) {
              vm.printer.$cancel();
              vm.printer.$save();
              cancel();
            }
            else {
              vm.printer.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          printer: function () {
            return lprinter;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return PrinterHelperBase;
  }
}());
